/**
 * Where each kind of account belongs.
 * @file src/web/shared/home.ts
 *
 * Three kinds of account, three homes, and none of them can use another's:
 * a firm's staff work in the firm app, platform admins in the platform
 * console, partners in the partner view. Every layout sends a visitor who
 * does not belong there here, rather than rendering a screen whose every
 * request would be refused.
 */

export interface AccountLike {
  role?: string;
  level?: string;
  tenantId?: string | null;
  mustChangePassword?: boolean;
}

export type AccountKind = 'firm' | 'platform' | 'partner' | 'none';

export function accountKind(user: AccountLike | null | undefined): AccountKind {
  if (!user) return 'none';
  if (user.tenantId) return 'firm';
  if (user.role === 'admin' && user.level === 'system') return 'platform';
  if (user.role === 'admin' && user.level === 'org') return 'partner';
  return 'none';
}

export function homeFor(user: AccountLike | null | undefined): string {
  if (!user) return '/auth/login';
  if (user.mustChangePassword) return '/auth/change-password';
  switch (accountKind(user)) {
    case 'platform':
      return '/platform';
    case 'partner':
      return '/partner';
    case 'firm':
      return '/overview';
    default:
      return '/';
  }
}
